import { render } from "./resume.vue?vue&type=template&id=a7a57f6a&scoped=true"
import script from "./resume.vue?vue&type=script&lang=js"
export * from "./resume.vue?vue&type=script&lang=js"

import "./resume.vue?vue&type=style&index=0&id=a7a57f6a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a57f6a"]])

export default __exports__